import { render, staticRenderFns } from "./runForIt_v1.vue?vue&type=template&id=1182c8ef&scoped=true&"
import script from "./runForIt_v1.vue?vue&type=script&lang=js&"
export * from "./runForIt_v1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1182c8ef",
  null
  
)

export default component.exports